module.exports = __webpack_public_path__ + "img/tilstand_fysisk_kjemiske_kvalitetselement.c4bf1a24.jpg";